module.exports = __webpack_public_path__ + "img/Color.2d038c8a.svg";